import { useEffect, useRef, useState } from "react";
import { Share2, Download } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { api } from "@/lib/api";

const W = 1080;
const wrap = (ctx, text, max) => {
  const words = text.split(" ");
  const lines = [];
  let cur = "";
  words.forEach((w) => {
    if (ctx.measureText(cur + " " + w).width > max && cur) {
      lines.push(cur);
      cur = w;
    } else cur = cur ? cur + " " + w : w;
  });
  if (cur) lines.push(cur);
  return lines.slice(0, 8);
};

export const ReviewShare = () => {
  const { t } = useLang();
  const rs = t.dash.reviewShare;
  const canvasRef = useRef(null);
  const [reviews, setReviews] = useState([]);
  const [sel, setSel] = useState("");

  useEffect(() => {
    api.get("/testimonials").then((r) => {
      setReviews(r.data);
      if (r.data[0]) setSel(r.data[0].id);
    }).catch(() => {});
  }, []);

  const review = reviews.find((r) => r.id === sel);

  useEffect(() => {
    if (!review || !canvasRef.current) return;
    const ctx = canvasRef.current.getContext("2d");
    ctx.fillStyle = "#0a0a0a";
    ctx.fillRect(0, 0, W, W);
    const g = ctx.createRadialGradient(W / 2, 400, 50, W / 2, 400, 900);
    g.addColorStop(0, "rgba(255,121,0,0.22)");
    g.addColorStop(1, "rgba(255,121,0,0)");
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, W, W);
    ctx.textAlign = "center";
    ctx.fillStyle = "#ffffff";
    ctx.font = "600 44px Arial";
    ctx.fillText("Smart Telecom Advisor", W / 2, 130);
    ctx.fillStyle = "#FBBC04";
    ctx.font = "700 64px Arial";
    ctx.fillText("★".repeat(review.rating) + "☆".repeat(5 - review.rating), W / 2, 260);
    let y = 380;
    ctx.fillStyle = "#ffffff";
    ctx.font = "600 46px Arial";
    wrap(ctx, `“${review.text}”`, 880).forEach((l) => {
      ctx.fillText(l, W / 2, y);
      y += 62;
    });
    ctx.fillStyle = "#FF7900";
    ctx.font = "700 40px Arial";
    ctx.fillText(`— ${review.name}`, W / 2, y + 40);
    ctx.fillStyle = "#FF7900";
    ctx.font = "700 42px Arial";
    ctx.fillText("+32 473 22 33 44", W / 2, W - 130);
    ctx.fillStyle = "rgba(255,255,255,0.6)";
    ctx.font = "400 36px Arial";
    ctx.fillText("www.smartelecomadvisor.be", W / 2, W - 70);
  }, [review]);

  const download = () => {
    const a = document.createElement("a");
    a.href = canvasRef.current.toDataURL("image/png");
    a.download = `avis-${review?.name?.replace(/\s+/g, "-") || "client"}.png`;
    a.click();
  };

  if (!reviews.length) return null;

  return (
    <div className="bg-[#111111] border border-white/10 p-6 md:p-8 mb-10" data-testid="review-share-panel">
      <p className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-white/40 mb-5">
        <Share2 className="w-4 h-4 text-[#FBBC04]" /> {rs.title}
      </p>
      <div className="flex flex-col md:flex-row gap-6 items-start">
        <div className="flex-1 space-y-3">
          <select
            value={sel}
            onChange={(e) => setSel(e.target.value)}
            data-testid="review-share-select"
            className="w-full bg-black/40 border border-white/15 px-3 py-2 text-sm outline-none focus:border-[#FF7900] transition-colors duration-300 cursor-pointer"
          >
            {reviews.map((r) => (
              <option key={r.id} value={r.id} className="bg-[#111]">
                {r.name} · {r.rating}/5 — {r.text.slice(0, 40)}…
              </option>
            ))}
          </select>
          <button
            onClick={download}
            data-testid="review-share-download"
            className="inline-flex items-center gap-2 bg-[#FF7900] hover:bg-white hover:text-black text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-colors duration-300"
          >
            <Download className="w-4 h-4" /> {rs.download}
          </button>
        </div>
        <canvas ref={canvasRef} width={W} height={W} data-testid="review-share-canvas" className="w-[280px] rounded-xl border border-white/10 shrink-0 shadow-2xl" />
      </div>
    </div>
  );
};
